import { Container, Row } from "reactstrap";
import PatientsTable from "./PatientsTable";

const DashboardContainer = () => {
  return (
    <Container fluid className="default-dashboard dashboard-2">
      <Row className="widget-grid">
        <PatientsTable />
      </Row>
    </Container>
  );
};

export default DashboardContainer;
